import Link from 'next/link'
import React, { FC } from 'react'
import { journalSections_sections_nodes } from '../../../__generated__/journalSections'
import cx from 'classnames'
import css from './TopBar.module.scss'
import { useRouter } from 'next/router'

const TopBar: FC<{ sections: journalSections_sections_nodes[] }> = ({
  sections,
}) => {
  const { query } = useRouter()

  if (sections?.length < 1) {
    return null
  }

  return (
    <nav className={css.wrapper}>
      <ul className={css.list}>
        <li>
          <Link href="/journal" passHref>
            <a className={cx(css.link, !query.section && css.active)}>все</a>
          </Link>
        </li>

        {sections?.map((section) => (
          <li key={section.id}>
            <Link href={`/journal/${section.code}`} passHref>
              <a
                className={cx(
                  css.link,
                  query.section === section.code && css.active,
                )}
              >
                {section.name}
              </a>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default TopBar
